module.exports = __webpack_public_path__ + "static/media/realtalk_sd_rinc72a5aa3fdff2417b9fc7f03149ef9b6.webp";